import React from 'react';

const ConfirmDialog = ({
  isOpen,
  title = 'Confirmar',
  message = '¿Estás seguro?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  variant = 'danger',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  if (!isOpen) return null;

  const confirmClass = variant === 'danger'
    ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
    : 'bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500';

  return (
    <div className="modal-overlay">
      <div className="modal-content max-w-md">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        </div>
        <div className="p-6">
          <p className="text-gray-700">{message}</p>
          <div className="mt-6 flex justify-end space-x-3">
            <button
              className="btn-secondary"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelText}
            </button>
            <button
              className={`btn-primary ${confirmClass}`}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? 'Procesando...' : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

